module.exports = __webpack_public_path__ + "static/media/indonesia.e7625a23.svg";